module.exports = __webpack_public_path__ + "img/edit.93106748.svg";